import { render, staticRenderFns } from "./ChefiaPendenteAprovacao.vue?vue&type=template&id=62dfb95e&"
import script from "./ChefiaPendenteAprovacao.vue?vue&type=script&lang=js&"
export * from "./ChefiaPendenteAprovacao.vue?vue&type=script&lang=js&"
import style0 from "./ChefiaPendenteAprovacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports